import { ReactNode } from 'react';
import Image from 'next/image';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';

const modalStyle = {
  textAlign: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  boxShadow: 24,
  py: 3,
  px: 2,
  borderRadius: '4px',
};

interface IModalDefaultProps {
  isOpen: boolean;
  onClose: () => void;
  src?: string;
  alt?: string;
  title?: string;
  subtitle?: ReactNode;
  textButton?: string;
  onClickButton?: () => void;
  children?: ReactNode;
}

export default function ModalDefault({
  isOpen,
  onClose,
  src,
  alt,
  title,
  subtitle,
  textButton,
  onClickButton,
  children,
}: IModalDefaultProps) {
  return (
    <>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={{ position: 'absolute', right: 16, top: 16 }}>
            <IconButton
              size="small"
              color="inherit"
              onClick={onClose}
              aria-label="button-close-modal"
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ mt: 3 }}>
            {src && <Image width="236px" height="143px" src={src} alt={alt} />}
          </Box>
          <Typography sx={{ mt: 2 }} variant="h6" component="h3">
            {title}
          </Typography>
          <Typography
            variant="body2"
            component="h6"
            sx={{ my: 1, hyphens: 'none', opacity: '0.7' }}
          >
            {subtitle}
          </Typography>
          {children}
          {textButton && (
            <Button
              sx={{ mt: 2 }}
              variant="contained"
              fullWidth
              onClick={onClickButton ? () => onClickButton() : undefined}
            >
              {textButton}
            </Button>
          )}
        </Box>
      </Modal>
    </>
  );
}

export type { IModalDefaultProps };
